import React from 'react';
import PropTypes from 'prop-types';

import PageContainer from 'shared-components/PageContainer/PageContainer';
import styles from './Layout.module.css';

const Layout = ({ children }) => (
  <PageContainer className={styles.container}>{children}</PageContainer>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
